import { useTranslation } from "react-i18next";
import { PackageX, Store, Languages } from "lucide-react";
import PublicLayout from "@/components/public/PublicLayout";
import Seo from "@/components/public/Seo";
import { PageHero, SectionHead, CtaBand } from "@/components/public/blocks";

export default function About() {
  const { t } = useTranslation();
  const values = [
    { icon: PackageX, title: t("site.about.v1t"), body: t("site.about.v1b") },
    { icon: Store, title: t("site.about.v2t"), body: t("site.about.v2b") },
    { icon: Languages, title: t("site.about.v3t"), body: t("site.about.v3b") },
  ];
  return (
    <PublicLayout testId="about-page">
      <Seo path="/about" title={t("site.seo.aboutTitle")} description={t("site.seo.aboutDesc")} />
      <PageHero badge={t("site.nav.about")} title={t("site.about.title")} subtitle={t("site.about.subtitle")} />
      <section className="max-w-3xl mx-auto px-5 pb-16 space-y-5 text-slate-300 text-base md:text-lg leading-relaxed">
        <p>{t("site.about.p1")}</p>
        <p>{t("site.about.p2")}</p>
      </section>
      <section className="max-w-7xl mx-auto px-5 py-20 border-t border-white/10">
        <SectionHead title={t("site.about.valuesTitle")} />
        <ul className="grid gap-4 md:grid-cols-3">
          {values.map((v) => (
            <li key={v.title} className="rounded-2xl border border-white/10 bg-white/[0.04] p-6">
              <v.icon className="w-6 h-6 text-brand" aria-hidden="true" />
              <h3 className="font-display font-bold text-lg mt-3">{v.title}</h3>
              <p className="text-sm text-slate-400 mt-2">{v.body}</p>
            </li>
          ))}
        </ul>
      </section>
      <CtaBand title={t("site.home.sellTitle")} body={t("site.home.sellBody")} to="/sell" cta={t("site.home.sellCta")} testId="about-sell-cta" />
    </PublicLayout>
  );
}
